//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'APACHE2_info'

}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Anae/APACHE2_info.vue